import { AlertTriangle } from "lucide-react";
import { useCheckout } from "@/hooks/billing/useCheckout";
import {
  useSubscription,
  type BillingOrgRef,
} from "@/hooks/billing/useSubscription";
import { PlanGrid } from "./PlanGrid";
import { CurrentPlan } from "./CurrentPlan";

export function PanelContent({ org }: { org?: BillingOrgRef }) {
  const { handleManageBilling } = useCheckout();
  const { data } = useSubscription(org?.id);
  const hasActiveSubscription = data?.hasActiveSubscription ?? false;
  const canceled = data?.canceled ?? false;

  return (
    <div className="space-y-5 p-6">
      {canceled && (
        <div className="flex items-start gap-3 rounded-lg border-[0.5px] border-border bg-muted/60 px-4 py-3">
          <AlertTriangle className="h-4 w-4 shrink-0 mt-0.5 text-foreground" />
          <div className="flex-1 space-y-1 text-sm">
            <p className="font-medium text-foreground">
              Subscription cancelled
            </p>
            <p className="text-muted-foreground">
              Your plan stays active until the end of the billing period.{" "}
              <button
                type="button"
                onClick={() => handleManageBilling(org?.slug)}
                className="text-foreground underline underline-offset-2 hover:no-underline"
              >
                Reactivate or update
              </button>
              .
            </p>
          </div>
        </div>
      )}

      {hasActiveSubscription ? (
        <CurrentPlan org={org} />
      ) : (
        <PlanGrid orgSlug={org?.slug} />
      )}
    </div>
  );
}
